<template>
  <div>
    <button-gutter>
        <el-button type="warning"
                   size="mini"
                   @click="approveInvoice(scope.row.id)"
                   v-if="scope.row.status === 2">财务审批
        </el-button>


        <el-button type="primary"
                   size="mini"
                   @click="completeInvoice(scope.row.id)"
                   v-if="scope.row.status === 5 && !scope.row.is_split">开票完成
        </el-button>

        <el-button type="danger"
                   size="mini"
                   @click="voidInvoice(scope.row.id)"
                   v-if="scope.row.status === 8">作废
        </el-button>
      <!--已开票-->
      <el-button type="danger"
                 size="mini"
                 @click="completeInvoice(scope.row.id)"
                 v-if="scope.row.status === 6 && !scope.row.is_split">修改
      </el-button>

    </button-gutter>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  props: {
    scope: Object,
  },
  methods: {
    approveInvoice (id) {
      this.$emit('approveInvoice', Object.assign({}, this.params, {id: id}))
    },
    completeInvoice (id) {
      this.$emit('completeInvoice', Object.assign({}, this.params, {id: id}))
    },
    voidInvoice (id) {
      this.$emit('voidInvoice', Object.assign({}, this.params, {id: id}))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/ApproveOperationButtons.vue